<template>
  <aha-modal
    v-if="isModalShowing"
    @hide="hide()"
    :title="`${ $i18nPresenter.t('Rename:') } ${folder.folderName}`"
  >
    <form @submit.prevent="handleRenameFolder()">
      <div class="relative">
        <aha-input
          focus
          :maxLength="100"
          v-model="folderName"
        />
      </div>
    </form>
    <template #action>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
      <aha-button
        :disabled="isRenamingFolder"
        @click="handleRenameFolder()"
        has-margin-left
      >
        <aha-spinner variant="white" v-if="isRenamingFolder" class="mr-1" />
        {{ $i18nPresenter.t("Save") }}
      </aha-button>
    </template>
    <div class="pt-2 text-red-50" v-if="textError">
      {{ textError }}
    </div>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// api
import FolderApi from '@/api/folder'

// utils
import Utils from '@/util'

// constants
import constants from '@/constant'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      folderName: '',
      isRenamingFolder: false,
      textError: '',
      isModalShowing: false,
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.isModalShowing = true
    this.folderName = this.folder.folderName
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
    ]),
    trackEvent(label, value) {
      Utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        label,
        value,
      )
    },
    handleAfterCallAPIRenameFolder(renamedFolderId) {
      const newFolder = this.folders.map((item) => {
        if (item.folderId === renamedFolderId) {
          return { ...item, folderName: this.folderName }
        }
        return item
      })
      this.setFoldersAction(newFolder)
      this.isRenamingFolder = false
      Utils.showToastSuccess(`"${this.folder.folderName}" ${this.$i18nPresenter.t('renamed to')} "${this.folderName.trim()}"`)
      this.trackEvent(
        'Presentation List > Rename Folder > Succeeded',
        `Folder name: ${this.folderName}`,
      )
      this.hide()
    },
    handleErrorRenameFolder(err, text) {
      this.isRenamingFolder = false
      if (err.body.message === 'folderName must be unique') {
        this.textError = this.$i18nPresenter.t('This folder name is already in use, please enter something else.')
      } else {
        Utils.showToastError(text)
      }
    },
    async handleRenameFolder() {
      this.isRenamingFolder = true
      this.trackEvent(
        'Presentation List > Rename Folder > Submit',
      )
      if (this.folderName.trim() === '') {
        this.textError = this.$i18nPresenter.t('Please enter a name for folder.')
        this.isRenamingFolder = false
        return
      }
      if (this.folderName === this.folder.folderName) {
        this.textError = this.$i18nPresenter.t('This is your current folder name.')
        this.isRenamingFolder = false
        return
      }
      try {
        const result = await FolderApi.updateFolderById(this.folder.folderId, {
          folderName: this.folderName.trim(),
        })
        this.handleAfterCallAPIRenameFolder(result.body.folder.folderId)
      } catch (error) {
        this.handleErrorRenameFolder(error, 'Rename folder failed')
        this.trackEvent(
          'Presentation List > Rename Folder > Failed',
          `Error: ${error.body.message}`,
        )
      }
    },
    hide() {
      this.$emit('hide')
    },
    isValidatedFolderName() {
      if (this.folderName.trim() === '') {
        this.textError = this.$i18nPresenter.t('Please enter a name for folder.')
        this.isRenamingFolder = false
        return false
      }
      if (this.folderName === this.folder.folderName) {
        this.textError = this.$i18nPresenter.t('This is your current folder name.')
        this.isRenamingFolder = false
        return false
      }
      return true
    },
  },
}
</script>
